import React from 'react'
import { Route, Switch } from 'react-router-dom'
// import CardGame from './haiou/CardGame'
import CardGame_xiniu from './xiniu/CardGame'
import CardGame_qx from './type_qx/CardGame'
// import CardGame_haiou from './haiou/CardGame' remove
import CardGameLog from './CardGameLog'

let CardGame
switch (process.env['REACT_APP_CHANNEL']){
  // todo channel
  case 'ytyg':
  case 'dyyg':
  case 'qxtj':
  case 'qxyg':
  case 'qxdg':
  case 'tjyg':
    CardGame = CardGame_qx
    break
  default:
    CardGame = CardGame_xiniu
}

class CardGameRouter extends React.PureComponent {
  render () {
    return <Switch>
      <Route path={window.PATH.CARD_GAME}
             component={CardGame}
             exact
      />
      <Route path={window.PATH.CARD_GAME_LOG} component={CardGameLog}/>
    </Switch>
  }
}

export default CardGameRouter
